/**
 * Removes "auto" union values from props.
 *
 * @template TProps - The props to remove "auto" from.
 */ /**
 * Processes props by resolving any props with "auto" with a processed value.
 *
 * @param props - The props to process.
 * @param processors - Map of auto-processors to use.
 */ function processAutoProps(props, processors) {
    return Object.keys(props).reduce((processed, key)=>({
            ...processed,
            [key]: props[key] === 'auto' ? key in processors ? processors[key] : undefined : props[key]
        }), {});
}

export { processAutoProps };
//# sourceMappingURL=auto-props.js.map
